import React from 'react';
import { useParams, useLocation, Link } from 'react-router-dom';
import { Alert } from 'antd';

import { EditorShell, type CreationTarget } from './EditorShell';
import { getModule } from './registry';
import type { EditorModule, NewPuzzleParams, ImportedState } from './types';
import { isEmptyCreationMeta, type CreationMeta } from '../catalog/apply-creation-meta';

// Entrada da rota /admin/editor/:kind/:id? — resolve o módulo pelo `kind`, lê o `id`
// (ausente = criação) e os params OU o doc importado vindos por router state (NewGameWizard / ImportXmlCard), e
// delega tudo ao shell agnóstico. O "+ Novo jogo" manda também `meta` (edição/tema/dificuldade), que o shell
// grava depois do primeiro "Salvar", na API do catálogo do módulo (`entry.catalog`).

export const EditorRoute: React.FC = () => {
  const { kind, id } = useParams<{ kind: string; id?: string }>();
  const location = useLocation();
  const module = getModule(kind ?? '');

  if (!module) {
    return (
      <div style={{ maxWidth: 1040, margin: '0 auto', padding: 24 }}>
        <Alert type="error" message={`Editor "${kind}" não encontrado.`} showIcon />
        <p style={{ marginTop: 16 }}>
          <Link to="/admin?tab=jogos">← voltar ao painel</Link>
        </p>
      </div>
    );
  }

  const state = location.state as {
    params?: NewPuzzleParams;
    imported?: ImportedState;
    meta?: CreationMeta;
  } | null;
  const params = state?.params ?? null;
  const imported = state?.imported ?? null;
  const meta = state?.meta;
  const creation: CreationTarget | null =
    id == null && meta && !isEmptyCreationMeta(meta) ? { catalog: module.entry.catalog, meta } : null;

  return (
    <div style={{ maxWidth: 1040, margin: '0 auto', padding: 24 }}>
      <p>
        <Link to="/admin?tab=jogos">← voltar ao painel</Link>
      </p>
      <h1 style={{ marginTop: 0 }}>
        Editor — {module.label}
        {id ? ` #${id}` : ' (novo)'}
      </h1>
      <EditorShell
        module={module as EditorModule<unknown, unknown>}
        id={id ? Number(id) : null}
        params={params}
        imported={imported}
        creation={creation}
      />
    </div>
  );
};

export default EditorRoute;
